/*
 * Module for the Benefit Payroll Changes Report criteria page
 */
rs.module("content/reports/benefitpayrollchangescriteria",

    ["common/select-helper"],

    function (selectHelper) {

        function initialize(jsSelectors, sortOptions) {

            var criteria = $.js(jsSelectors.criteria);

            var includeDetailCheckbox = criteria.js(jsSelectors.includeDetailCheckbox);
            var sortSelect = criteria.js(jsSelectors.sortSelect);

            // Get Select Helper for _sortOptions selector since we're updating its options and properties
            var sortOptionsSelectHelper = selectHelper.getHelper(sortSelect);

            // call includeDetailChanged() on ready so page behaves correctly on initialize
            $(includeDetailChanged);

            // register checkbox change event
            includeDetailCheckbox.change(includeDetailChanged);

            // disable and clear the sort options dropdown based on the status of Include Detail checkbox 
            function includeDetailChanged() {

                if (includeDetailCheckbox.is(":checked")) {
                    sortOptionsSelectHelper.setDisabled(false);
                    sortOptionsSelectHelper.replaceOptions(sortOptions);     
                }
                else {        
                    sortOptionsSelectHelper.clearOptions();
                    sortOptionsSelectHelper.setDisabled(true);                                         
                }
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);